import styled from "styled-components";

export const Styled = {
  Wrapper: styled.div`
    /* border: 1px solid #f00; */
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 40px 60px;
    padding-bottom: 14vh;
    // max-width: 1440px;
    margin: auto;
    min-height: 100vh;

    .ant-card {
      border-radius: 10px;
      // box-shadow: 0 20px 27px rgb(0 0 0 / 5%);
      box-shadow: none;
      border: 1px solid var(--border-color);
    }
    .ant-card-body {
      padding: 16px;
    }
    .ant-card-head {
      border-bottom: 1px solid var(--border-color) !important;
    }
  `,
  TopSection: styled.div`
    /* border: 1px solid #f00; */
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
  `,
  TopTextWrapper: styled.div`
    h1 {
      letter-spacing: -0.025em;
      font-weight: 700;
      font-size: 1.875rem;
      line-height: 2.25rem;
      color: var(--primary-text-color);
    }
    p {
      /* color: rgb(107 114 128 / var(--tw-text-opacity, 1)); */
      color: var(--secondary-text-color);
      margin-top: 0.5rem;
    }
  `,
  TopControlsWrapper: styled.div`
    display: flex;
    gap: 5px;
  `,

  CardHeading: styled.div``,

  Section: styled.div`
    border: 1px solid #f00;
  `,
};

export const CTAButton = styled.button`
  border: none;
  display: flex;

  --tw-ring-offset-color: hsl(var(--background));
  --tw-text-opacity: 1;
  color: hsl(0 0% 100% / var(--tw-text-opacity, 1));
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.25rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  --tw-bg-opacity: 1;
  background-color: hsl(265 89% 60% / var(--tw-bg-opacity, 1));
  border-radius: calc(var(--radius) - 2px);
  border-radius: 6px;
  white-space: nowrap;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;
  height: 2.25rem;
  display: inline-flex;
  cursor: pointer;

  &:hover {
    background-color: hsl(265 89% 60% / 0.9);
  }
`;

export const SettingsButton = styled.div`
  border: none;
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.25rem;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  white-space: nowrap;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;
  width: 2.5rem;
  height: 2.5rem;
  display: inline-flex;
  cursor: pointer;
  color: var(--primary-text-color);
`;

export const CardsWrapper = styled.div`
  @media (min-width: 768px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media (min-width: 1024px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  /* border: 1px solid #f00; */
  gap: 1rem;
  display: grid;
  /* margin-top: 15px; */

  .card {
    border-width: 1px;
    border: 1px solid var(--border-color);
    border-radius: 6px;
  }

  .heading {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 1.5rem;
    padding-bottom: 0rem;

    .text {
      letter-spacing: -0.025em;
      font-weight: 700;
      font-size: 0.875rem;
      line-height: 1.25rem;
      color: var(--primary-text-color);
    }

    .icon {
      font-size: 20px;
      color: var(--secondary-text-color);
    }
  }
  .count_wrapper {
    padding: 1.5rem;
    padding-top: 0px;

    .number {
      font-weight: 700;
      font-size: 1.5rem;
      line-height: 2rem;
      color: var(--primary-text-color);
    }
    p {
      color: var(--secondary-text-color);
      font-size: 0.75rem;
      line-height: 1rem;
    }
  }
`;

export const TabbedSection = styled.div`
  /* border: 1px solid #f00; */
  /* background-color: rgb(241, 245, 249); */
  margin-top: 30px;

  /* color: hsl(var(--muted-foreground));
    padding: 0.25rem;
    background-color: hsl(var(--muted));
    border-radius: calc(var(--radius) - 2px); */

  ul.tablist {
    /* border: 1px solid #f00; */
    padding: 0;
    width: 100%;
    list-style: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* background-color: var(--secondary-bg); */
    background-color: var(--border-color);
    border-radius: 8px;

    li {
      /* border: 1px solid #f0f; */
      flex: 1;
      padding: 5px;
      display: flex;
      align-items: center;
      height: 50px;

      .button {
        /* border: 1px solid #f00; */
        background-color: inherit;
        width: 100%;
        height: 100%;
        cursor: pointer;
        color: var(--secondary-text-color);
        border-radius: 8px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;

        &.active {
          background-color: var(--primary-bg);
          color: var(--primary-text-color);
        }
      }
    }
  }
`;
